import { Button, Card, Typography, Divider, Form, Switch } from "antd";
import { Input } from "antd";
import { LeftOutlined } from "@ant-design/icons";
import { useNavigate, useParams } from "react-router-dom";
import toast from "react-hot-toast";
import { useEffect, useState } from "react";
import { changeLoader } from "../../../redux/reducers/loader";
import globalRequest from "../../../utils/global/globalRequest";
import * as Validation from "../../../utils/helper/validation";
import * as Apis from "../../../utils/helper/enum";
import { useDispatch } from "react-redux";
import config from "../../../config";
import { jwtDecode } from "jwt-decode";
import { addDeleteGetLocalStorage, storageKeys } from "../../../utils/global/localData";
import { checkPermissionAction } from "../../../utils/helper/utils";

const AddZone = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [statusState, setStatusState] = useState(true);
  const [fastestDeliveryState, setFastestDeliveryState] = useState(true);
  const [scheduleDeliveryState, setScheduleDeliveryState] = useState(true);
  const [guestOrderState, setGuestOrderState] = useState(true);

  let { id } = useParams();

  useEffect(() => {
    const userAccess = addDeleteGetLocalStorage(storageKeys?.USER_TOKEN, {}, "get");
    let permissionJson = [];
    if (userAccess) {
      const decoded = jwtDecode(userAccess);
      permissionJson = decoded?.user?.rolePermission?.permissionJson;
    }
    if (id) {
      if (!checkPermissionAction("Zones", permissionJson, "edit")) {
        navigate("/manage-zones");
      }
    } else {
      if (!checkPermissionAction("Zones", permissionJson, "add")) {
        navigate("/manage-zones");
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleInputChange = (name) => {
    form.setFields([
      {
        name,
        errors: [],
      },
    ]);
  };

  const handleSubmit = async (values) => {
    if (values.status === undefined) values.status = true;
    if (values.fastest_delivery === undefined) values.fastest_delivery = true;
    if (values.schedule_delivery === undefined) values.schedule_delivery = true;

    if (values.status) values.status = "active";
    else values.status = "inactive";

    if (values.fastest_delivery) values.fastest_delivery = 1;
    else values.fastest_delivery = 0;

    if (values.schedule_delivery) values.schedule_delivery = 1;
    else values.schedule_delivery = 0;

    if (values.allow_guest_order === undefined) values.allow_guest_order = true;
    if (values.allow_guest_order) values.allow_guest_order = 1;
    else values.allow_guest_order = 0;

    let cordinates = [];
    // eslint-disable-next-line array-callback-return
    inputData.coordinates.map((item) => {
      cordinates.push([item.lat, item.lng]);
    });
    values.coordinates = cordinates;
    if (values.coordinates.length === 0) {
      form.setFields([
        {
          name: "map_coordinates",
          errors: ["Please draw your polygon."],
        },
      ]);
      return false;
    }

    //

    let insert_data = {
      name: values.name,
      fastest_delivery: values.fastest_delivery,
      schedule_delivery: values.schedule_delivery,
      fastest_delivery_fee: {
        feePerKm: values.fastest_delivery_fee_per_km,
        minDeliveryFee: values.minimum_delivery_fee_for_fastest_delivery,
        maxDistance: values.maximum_distance_for_fastest_delivery,
      },
      schedule_delivery_fee: {
        feePerKm: values.schedule_delivery_fee_per_km,
        minDeliveryFee: values.minimum_delivery_fee_for_schedule_delivery,
        maxDistance: values.maximum_distance_for_schedule_delivery,
      },
      allow_guest_order: values.allow_guest_order,
      fastest_delivery_loading_time: values.fastest_delivery_loading_time,
      schedule_delivery_loading_time: values.schedule_delivery_loading_time,
      fastest_buffer_time: values.fastest_buffer_time,
      schedule_buffer_time: values.schedule_buffer_time,
      duration_fastest: values.duration_fastest,
      duration_schedule: values.duration_schedule,
      coordinates: values.coordinates,
      status: values.status,
    };

    dispatch(changeLoader(true));
    try {
      let url = Apis?.MANAGE_ZONE?.CREATE_ZONE;
      let method = "post";
      if (id) {
        url = Apis?.MANAGE_ZONE?.EDIT_ZONE + "/" + id;
        method = "put";
      }
      let response = await globalRequest(url, method, insert_data, {}, true);
      let apiResponse = response?.data;
      if (response?.status === 200) {
        let msg = "Zone created successfully";
        if (id) msg = "Zone updated successfully";
        toast.success(msg, {
          duration: 2000,
        });
        navigate("/manage-zones");
      } else {
        toast.error(apiResponse?.message);
      }
    } catch (e) {
      toast.error(e?.message);
    }
    dispatch(changeLoader(false));
  };

  const getZoneDetail = async (id) => {
    try {
      let response = await globalRequest(Apis.MANAGE_ZONE.GET_ZONE_DETAIL + "/" + id, "get", {}, {}, true);
      let apiResponse = response?.data;
      if (response?.status === 200) {
        let data = apiResponse?.data;
        form.setFieldValue("name", data?.name);
        form.setFieldValue("status", data?.status === "active" ? true : false);
        form.setFieldValue("schedule_delivery", data?.scheduleDelivery ? true : false);
        form.setFieldValue("fastest_delivery", data?.fastestDelivery ? true : false);

        form.setFieldValue("fastest_delivery_fee_per_km", data?.fastestDeliveryFee?.feePerKm);
        form.setFieldValue("minimum_delivery_fee_for_fastest_delivery", data?.fastestDeliveryFee?.minDeliveryFee);
        form.setFieldValue("maximum_distance_for_fastest_delivery", data?.fastestDeliveryFee?.maxDistance);

        form.setFieldValue("schedule_delivery_fee_per_km", data?.scheduleDeliveryFee.feePerKm);
        form.setFieldValue("minimum_delivery_fee_for_schedule_delivery", data?.scheduleDeliveryFee.minDeliveryFee);
        form.setFieldValue("maximum_distance_for_schedule_delivery", data?.scheduleDeliveryFee.maxDistance);

        form.setFieldValue("fastest_delivery_loading_time", data?.fastestDeliveryLoadingTime);
        form.setFieldValue("schedule_delivery_loading_time", data?.scheduleDeliveryLoadingTime);
        form.setFieldValue("fastest_buffer_time", data?.fastestBufferTime);
        form.setFieldValue("schedule_buffer_time", data?.scheduleBufferTime);
        form.setFieldValue("duration_fastest", data?.durationFastestDelivery);
        form.setFieldValue("duration_schedule", data?.durationScheduleDelivery);
        form.setFieldValue("allow_guest_order", data?.allowGuestOrder ? true : false);
          if (data?.allowGuestOrder) setGuestOrderState(true);
          else setGuestOrderState(false);

        if (data?.status === "active") setStatusState(true);
        else setStatusState(false);

        if (data?.fastestDelivery) setFastestDeliveryState(true);
        else setFastestDeliveryState(false);

        if (data?.scheduleDelivery) setScheduleDeliveryState(true);
        else setScheduleDeliveryState(false);

        let mapData = (data?.coordinates?.coordinates?.[0]).map(([lat, lng]) => ({ lat, lng }));
        setLatLng(mapData);

        // Initialize map with polygon data
        initMap(mapData);
      } else {
        toast.error(apiResponse?.message);
      }
    } catch (e) {
      toast.error(e?.message);
    }
  };

  useEffect(() => {
    if (id) getZoneDetail(id);
    else {
      setStatusState(true);
      setFastestDeliveryState(true);
      setScheduleDeliveryState(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [inputData, setInputData] = useState({
    coordinates: [],
  });
  const [latLng, setLatLng] = useState([]);
  const [errors, setErrors] = useState({});
  const [map, setMap] = useState(null);
  const [drawingManager, setDrawingManager] = useState(null);
  const [selectedColor] = useState("#007aaf");

  const drawingPolygon = () => {
    const drawingManagerInstance = new window.google.maps.drawing.DrawingManager({
      drawingMode: window.google.maps.drawing.OverlayType.POLYGON,
      drawingControl: true,
      drawingControlOptions: {
        position: window.google.maps.ControlPosition.TOP_CENTER,
        drawingModes: ["polygon"],
      },
      polygonOptions: {
        strokeColor: selectedColor,
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillColor: selectedColor,
        fillOpacity: 0.35,
        editable: true,
        zIndex: 1,
      },
    });

    if (drawingManagerInstance) {
      drawingManagerInstance.setMap(map);
    }

    window.google.maps.event.addListener(drawingManagerInstance, "overlaycomplete", (event) => {
      if (event.type === window.google.maps.drawing.OverlayType.POLYGON) {
        const polygonPath = event.overlay
          .getPath()
          .getArray()
          .map((coord) => ({
            lat: coord.lat(),
            lng: coord.lng(),
          }));
        setLatLng(polygonPath);
        setErrors({ ...errors, zone: "" });
      }
    });

    setDrawingManager(drawingManagerInstance);
  };

  const initMap = (defaultData = [], zoomLevel = 10) => {
    const mapInstance = new window.google.maps.Map(document.getElementById("map"), {
      center: {
        lat: Number(config.lat),
        lng: Number(config.lng),
      },
      zoom: zoomLevel,
    });

    if (mapInstance) {
      setMap(mapInstance);
    }

    if (defaultData.length !== 0) {
      const defaultPolygon = new window.google.maps.Polygon({
        paths: defaultData,
        editable: true,
        strokeColor: selectedColor,
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillColor: selectedColor,
        fillOpacity: 0.35,
        zIndex: 1,
      });

      defaultPolygon.setMap(mapInstance);

      // Calculate bounds and set center/zoom dynamically
      const bounds = new window.google.maps.LatLngBounds();
      defaultData.forEach((point) => {
        bounds.extend(new window.google.maps.LatLng(point.lat, point.lng));
      });

      mapInstance.fitBounds(bounds); // Automatically adjusts zoom and centers the polygon

      // Update Lat/Lng dynamically when polygon is edited
      window.google.maps.event.addListener(defaultPolygon.getPath(), "set_at", () => {
        const updatedLatLng = defaultPolygon
          .getPath()
          .getArray()
          .map((point) => ({
            lat: point.lat(),
            lng: point.lng(),
          }));
        setLatLng(updatedLatLng);
      });

      window.google.maps.event.addListener(defaultPolygon.getPath(), "insert_at", () => {
        const updatedLatLng = defaultPolygon
          .getPath()
          .getArray()
          .map((point) => ({
            lat: point.lat(),
            lng: point.lng(),
          }));
        setLatLng(updatedLatLng);
      });
    }
  };

  useEffect(() => {
    if (latLng.length > 0) {
      setInputData((prev) => ({
        ...prev,
        coordinates: latLng,
      }));
    }
  }, [latLng]);

  useEffect(() => {
    const script = document.createElement("script");
    script.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyDPV2HCRku3C8x4bqMczeatcoc87P9SS28&libraries=drawing`;
    script.async = true;
    script.defer = true;
    document.head.appendChild(script);

    script.onload = () => {
      initMap();
    };

    return () => {
      document.head.removeChild(script);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (map) {
      //drawingPolygon();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [map]);

  useEffect(() => {
    if (drawingManager && inputData?.coordinates?.length) {
      drawingManager.setMap(null);
    }
  }, [drawingManager, inputData?.coordinates]);

  return (
    <>
      <Card>
        <Typography className="text-xl font-semibold" align={"left"}>
          <LeftOutlined className="mr-2" onClick={() => navigate(-1)} />
          {id ? "Edit" : "Add"} Zone
        </Typography>
        <Divider />
        <div className="min-h-[calc(100vh_-_305px)]">
          <Form
            form={form}
            onFinish={handleSubmit}
            layout="vertical"
            style={{
              maxWidth: 600,
              width: "100%",
            }}
            initialValues={{
              remember: true,
            }}
            autoComplete="off"
          >
            <Form.Item
              label="Zone Name (English)"
              name="name"
              rules={[
                {
                  required: true,
                  message: "Please enter your Zone Name (English).",
                },
              ]}
            >
              <Input
                size="large"
                onChange={(e) => {
                  let value = Validation.strFormat(e.target.value, "text");
                  form.setFieldValue("name", value.trimStart());
                  handleInputChange("name");
                }}
              />
            </Form.Item>

            <Form.Item
              label="Delivery fees/KM for fastest delivery"
              name="fastest_delivery_fee_per_km"
              rules={[
                {
                  required: true,
                  message: "Please enter your Delivery fees/KM for fastest delivery.",
                },
                {
                validator: (_, value) =>
                  !value || /^\d+(\.\d{1,2})?$/.test(value)
                    ? Promise.resolve()
                    : Promise.reject(new Error("Only numeric values (up to 2 decimal places) are allowed.")),
                },
              ]}
            >
              <Input
                size="large"
                onChange={(e) => {
                  let value = Validation.strFormat(e.target.value);
                  form.setFieldValue("fastest_delivery_fee_per_km", value.trimStart());
                  handleInputChange("fastest_delivery_fee_per_km");
                }}
              />
            </Form.Item>
            <Form.Item
              label="Minimum Delivery Fee for fastest delivery"
              name="minimum_delivery_fee_for_fastest_delivery"
              rules={[
                {
                  required: true,
                  message: "Please enter your Minimum Delivery fees for fastest delivery.",
                },
                {
                validator: (_, value) =>
                  !value || /^\d+(\.\d{1,2})?$/.test(value)
                    ? Promise.resolve()
                    : Promise.reject(new Error("Only numeric values (up to 2 decimal places) are allowed.")),
                },
              ]}
            >
              <Input
                size="large"
                onChange={(e) => {
                  let value = Validation.strFormat(e.target.value);
                  form.setFieldValue("minimum_delivery_fee_for_fastest_delivery", value.trimStart());
                  handleInputChange("minimum_delivery_fee_for_fastest_delivery");
                }}
              />
            </Form.Item>
            <Form.Item
              label="Maximum Distance for fastest delivery"
              name="maximum_distance_for_fastest_delivery"
              rules={[
                {
                  required: true,
                  message: "Please enter your Maximum Distance for fastest delivery.",
                },
                {
                validator: (_, value) =>
                  !value || /^\d+(\.\d{1,2})?$/.test(value)
                    ? Promise.resolve()
                    : Promise.reject(new Error("Only numeric values (up to 2 decimal places) are allowed.")),
                },
              ]}
            >
              <Input
                size="large"
                onChange={(e) => {
                  let value = Validation.strFormat(e.target.value);
                  form.setFieldValue("maximum_distance_for_fastest_delivery", value.trimStart());
                  handleInputChange("maximum_distance_for_fastest_delivery");
                }}
              />
            </Form.Item>

            <Form.Item
              label="Delivery fees/KM for scheduled delivery"
              name="schedule_delivery_fee_per_km"
              rules={[
                {
                  required: true,
                  message: "Please enter your Delivery fees/KM for scheduled delivery.",
                },
                {
                validator: (_, value) =>
                  !value || /^\d+(\.\d{1,2})?$/.test(value)
                    ? Promise.resolve()
                    : Promise.reject(new Error("Only numeric values (up to 2 decimal places) are allowed.")),
                },
              ]}
            >
              <Input
                size="large"
                onChange={(e) => {
                  let value = Validation.strFormat(e.target.value);
                  form.setFieldValue("schedule_delivery_fee_per_km", value.trimStart());
                  handleInputChange("schedule_delivery_fee_per_km");
                }}
              />
            </Form.Item>
            <Form.Item
              label="Mimimum Delivery fees for scheduled delivery"
              name="minimum_delivery_fee_for_schedule_delivery"
              rules={[
                {
                  required: true,
                  message: "Please enter your Minimim Delivery fees for scheduled delivery.",
                },
                {
                validator: (_, value) =>
                  !value || /^\d+(\.\d{1,2})?$/.test(value)
                    ? Promise.resolve()
                    : Promise.reject(new Error("Only numeric values (up to 2 decimal places) are allowed.")),
                },
              ]}
            >
              <Input
                size="large"
                onChange={(e) => {
                  let value = Validation.strFormat(e.target.value);
                  form.setFieldValue("minimum_delivery_fee_for_schedule_delivery", value.trimStart());
                  handleInputChange("minimum_delivery_fee_for_schedule_delivery");
                }}
              />
            </Form.Item>
            <Form.Item
              label="Maximum Distance for scheduled delivery"
              name="maximum_distance_for_schedule_delivery"
              rules={[
                {
                  required: true,
                  message: "Please enter your Maximum Delivery fees for scheduled delivery.",
                },
                {
                validator: (_, value) =>
                  !value || /^\d+(\.\d{1,2})?$/.test(value)
                    ? Promise.resolve()
                    : Promise.reject(new Error("Only numeric values (up to 2 decimal places) are allowed.")),
                },
              ]}
            >
              <Input
                size="large"
                onChange={(e) => {
                  let value = Validation.strFormat(e.target.value);
                  form.setFieldValue("maximum_distance_for_schedule_delivery", value.trimStart());
                  handleInputChange("maximum_distance_for_schedule_delivery");
                }}
              />
            </Form.Item>

            <Form.Item
              label="Loading time for fastest delivery"
              name="fastest_delivery_loading_time"
              rules={[
                {
                  required: true,
                  message: "Please enter your Loading time for fastest delivery.",
                },
                {
                  validator: (_, value) => {
                    if (!value) {
                      return Promise.resolve(); // Skip further validation if required fails
                    }
                    // Ensure the value is a number and validate it
                    if (Number(value) > 0) {
                      return Promise.resolve();
                    }
                    return Promise.reject(new Error("Please provide a value greater than zero."));
                  },
                },
              ]}
            >
              <Input
                size="large"
                maxLength={8}
                onChange={(e) => {
                  let value = Validation.strFormat(e.target.value, "number");
                  form.setFieldValue("fastest_delivery_loading_time", value.trimStart());
                  handleInputChange("fastest_delivery_loading_time");
                }}
                addonAfter={<span>min</span>}
              />
            </Form.Item>

            <Form.Item
              label="Loading time for scheduled delivery"
              name="schedule_delivery_loading_time"
              rules={[
                {
                  required: true,
                  message: "Please enter your Loading time for scheduled delivery.",
                },
                {
                  validator: (_, value) => {
                    if (!value) {
                      return Promise.resolve(); // Skip further validation if required fails
                    }
                    // Ensure the value is a number and validate it
                    if (Number(value) > 0) {
                      return Promise.resolve();
                    }
                    return Promise.reject(new Error("Please provide a value greater than zero."));
                  },
                },
              ]}
            >
              <Input
                size="large"
                maxLength={8}
                onChange={(e) => {
                  let value = Validation.strFormat(e.target.value, "number");
                  form.setFieldValue("schedule_delivery_loading_time", value.trimStart());
                  handleInputChange("schedule_delivery_loading_time");
                }}
                addonAfter={<span>min</span>}
              />
            </Form.Item>
            <Form.Item
              label="Buffer time for fastest delivery"
              name="fastest_buffer_time"
              rules={[
                {
                  required: true,
                  message: "Please enter your Buffer time for fastest delivery.",
                },
                {
                  validator: (_, value) => {
                    if (!value) {
                      return Promise.resolve(); // Skip further validation if required fails
                    }
                    // Ensure the value is a number and validate it
                    if (Number(value) > 0) {
                      return Promise.resolve();
                    }
                    return Promise.reject(new Error("Please provide a value greater than zero."));
                  },
                },
              ]}
            >
              <Input
                size="large"
                maxLength={8}
                onChange={(e) => {
                  let value = Validation.strFormat(e.target.value, "number");
                  form.setFieldValue("fastest_buffer_time", value.trimStart());
                  handleInputChange("fastest_buffer_time");
                }}
                addonAfter={<span>min</span>}
              />
            </Form.Item>
            <Form.Item
              label="Buffer time for scheduled delivery"
              name="schedule_buffer_time"
              rules={[
                {
                  required: true,
                  message: "Please enter your Buffer time for scheduled delivery.",
                },
                {
                  validator: (_, value) => {
                    if (!value) {
                      return Promise.resolve(); // Skip further validation if required fails
                    }
                    // Ensure the value is a number and validate it
                    if (Number(value) > 0) {
                      return Promise.resolve();
                    }
                    return Promise.reject(new Error("Please provide a value greater than zero."));
                  },
                },
              ]}
            >
              <Input
                size="large"
                maxLength={8}
                onChange={(e) => {
                  let value = Validation.strFormat(e.target.value, "number");
                  form.setFieldValue("schedule_buffer_time", value.trimStart());
                  handleInputChange("schedule_buffer_time");
                }}
                addonAfter={<span>min</span>}
              />
            </Form.Item>
            <Form.Item
              label="Duration per KM for fastest delivery"
              name="duration_fastest"
              rules={[
                {
                  required: true,
                  message: "Please enter your duration per KM for fastest delivery.",
                },
                {
                  validator: (_, value) => {
                    if (!value) {
                      return Promise.resolve(); // Skip further validation if required fails
                    }
                    // Ensure the value is a number and validate it
                    if (Number(value) > 0) {
                      return Promise.resolve();
                    }
                    return Promise.reject(new Error("Please provide a value greater than zero."));
                  },
                },
              ]}
            >
              <Input
                size="large"
                maxLength={8}
                onChange={(e) => {
                  let value = Validation.strFormat(e.target.value, "number");
                  form.setFieldValue("duration_fastest", value.trimStart());
                  handleInputChange("duration_fastest");
                }}
                addonAfter={<span>min</span>}
              />
            </Form.Item>
            <Form.Item
              label="Duration per KM for scheduled delivery"
              name="duration_schedule"
              rules={[
                {
                  required: true,
                  message: "Please enter your duration per KM for scheduled delivery.",
                },
                {
                  validator: (_, value) => {
                    if (!value) {
                      return Promise.resolve(); // Skip further validation if required fails
                    }
                    // Ensure the value is a number and validate it
                    if (Number(value) > 0) {
                      return Promise.resolve();
                    }
                    return Promise.reject(new Error("Please provide a value greater than zero."));
                  },
                },
              ]}
            >
              <Input
                size="large"
                maxLength={8}
                onChange={(e) => {
                  let value = Validation.strFormat(e.target.value, "number");
                  form.setFieldValue("duration_schedule", value.trimStart());
                  handleInputChange("duration_schedule");
                }}
                addonAfter={<span>min</span>}
              />
            </Form.Item>

            <Form.Item name="status">
              <div className="flex gap-5">
                <p className="text-sm w-[200px]">Zone Status</p>
                <Switch
                  checked={statusState}
                  className=""
                  onChange={(e) => {
                    form.setFieldValue("status", e);
                    setStatusState(e);
                  }}
                />
              </div>
            </Form.Item>
            <p className="text-base font-semibold mb-2">Delivery Type</p>
            <Form.Item name="fastest_delivery">
              <div className="flex gap-5 ">
                <p className="text-sm w-[200px]">Fastest Delivery</p>
                <Switch
                  checked={fastestDeliveryState}
                  className=""
                  onChange={(e) => {
                    form.setFieldValue("fastest_delivery", e);
                    setFastestDeliveryState(e);
                    // form.setFieldValue("schedule_delivery", e);
                    // setScheduleDeliveryState(e);
                  }}
                />
              </div>
            </Form.Item>

            <Form.Item name="schedule_delivery">
              <div className="flex gap-5">
                <p className="text-sm w-[200px]">Scheduled Delivery</p>
                <Switch
                  checked={scheduleDeliveryState}
                  className=""
                  onChange={(e) => {
                    form.setFieldValue("schedule_delivery", e);
                    setScheduleDeliveryState(e);
                    // form.setFieldValue("fastest_delivery", e);
                    // setFastestDeliveryState(e);
                  }}
                />
              </div>
            </Form.Item>
            <Form.Item name="allow_guest_order">
              <div className="flex gap-5">
                <p className="text-sm w-[200px]">Allow Guest Order</p>
                <Switch
                  checked={guestOrderState}
                  onChange={(e) => {
                    form.setFieldValue("allow_guest_order", e);
                    setGuestOrderState(e);
                  }}
                />
              </div>
            </Form.Item>
            <Form.Item name="map_coordinates">
              <div className="responsive-map-container mt-4">
                <div id="map" style={{ height: "500px" }}></div>
              </div>
            </Form.Item>
            <button
              className="border border-[#d9d9d9] py-1 px-4 rounded-[6px] ml-4"
              type="button"
              size="large"
              color="secondary"
              variant="outlined"
              onClick={() => {
                setInputData({
                  coordinates: [],
                  name: "",
                  id: 0,
                  status: "active",
                });
                setLatLng([]);
                //drawingPolygon();
                initMap();
              }}
            >
              RESET
            </button>
          </Form>
        </div>
        <Divider />
        <div className="flex justify-end gap-3">
          <Button onClick={() => navigate("/manage-zones")}>Cancel</Button>
          <Button type="primary" htmlType="submit" onClick={() => form.submit()}>
            Save
          </Button>
        </div>
      </Card>
    </>
  );
};
export default AddZone;
